import { apiBaseUrl } from "~/modules/Router/Auth/constant";
import { fetchAdapter } from "~/utils/fetch";
import { DaoMemberInfoType, ErrorTypes, ResultType } from "../../types";

export const getIsJoinedDao = async (params: {
  daoId: string;
  tokenGating?: boolean;
}): Promise<
  ResultType<
    | {
        isJoined: true;
        canEnter: boolean;
        daoMemberInfo: DaoMemberInfoType;
        rejectedContractConditionIds: string[];
        rejectedCurrencyConditionIds: string[];
      }
    | {
        isJoined: false;
        canEnter: boolean;
        daoMemberInfo: null;
        rejectedContractConditionIds: string[];
        rejectedCurrencyConditionIds: string[];
      },
    ErrorTypes
  >
> => {
  try {
    /*const url = `${apiBaseUrl}/daos/${params.daoId}/enters${
      params.tokenGating ? "?tokenGating=include" : ""
    }`;*/

    const url = `${apiBaseUrl}/daos/enters`;
    const pathname = location.pathname;
    const [, daoSubdomain] = /(?:@([a-zA-Z0-9-_]+))/.exec(pathname) ?? [];

    const fetchResult = await fetchAdapter(url, {
      method: `POST`,
      credentials: `include`,
      referrerPolicy: `no-referrer-when-downgrade`,
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        daoSubdomain: daoSubdomain,
        tokenGating: params.tokenGating ? "include" : "exclude",
      }),
    })
      .then((res) => {
        return { ok: true as const, value: res };
      })
      .catch(() => {
        return {
          ok: false as const,
          value: ErrorTypes.UnCategorizedError,
        };
      });
    if (!fetchResult.ok) {
      return fetchResult;
    }
    const { value: res } = fetchResult;

    if (res.status !== 200) {
      return {
        ok: false,
        value: ErrorTypes.UnCategorizedError,
      };
    }

    const json = await res.json();
    if (json?.code !== `000`) {
      return {
        ok: false,
        value: ErrorTypes.UnCategorizedError,
      };
    }

    const reason = json.data?.reason;
    const isDeleteOrKickMemberReject =
      reason?.type === "DELETE_MEMBER" || reason?.type === "KICK_MEMBER";
    const isTokenGatingReject = reason?.type === "TOKEN_GATING";

    if (isDeleteOrKickMemberReject) {
      return {
        ok: false,
        value: ErrorTypes.ReJoinDaoNotAllowedError,
      };
    }

    const isJoined = json.data.isEntered;
    const canEnter = json.data.canEnter;
    const member = json.data.member;
    const daoMemberInfo = isJoined
      ? {
          id: member.id,
          imageUrl: member.imageUrl ?? null,
          nftProfile: member.nftProfile
            ? {
                chain: member.chain,
                imageUrl: member.imageUrl,
              }
            : null,
          nickname: member.nickname,
          bio: member.bio,
        }
      : null;
    const rejectedContractConditionIds = isTokenGatingReject
      ? reason.contractConditionIdList
      : [];
    const rejectedCurrencyConditionIds = isTokenGatingReject
      ? reason.nativeTokenConditionIdList
      : [];

    return {
      ok: true,
      value: {
        isJoined,
        canEnter,
        daoMemberInfo,
        rejectedContractConditionIds,
        rejectedCurrencyConditionIds,
      },
    };
  } catch (error) {
    return {
      ok: false,
      value: ErrorTypes.UnCategorizedError,
    };
  }
};
